import type { Doc } from "@Aspecto/backend/convex/_generated/dataModel";

import { Button, buttonVariants } from "@/components/ui/button";
import { getGroupLabels } from "@/lib/group-labels";
import { cn } from "@/lib/utils";

export function OrgBrandingHeader({ company }: { company: Doc<"companies"> }) {
  const { pluralLower } = getGroupLabels(company.groupLabel);

  return (
    <div className="mb-6 text-center">
      {company.logoUrl ? (
        <img
          src={company.logoUrl}
          alt={company.name}
          className="mx-auto mb-3 h-10 w-10 rounded-lg object-cover"
        />
      ) : null}
      <h1 className="text-xl font-semibold tracking-tight">{company.name}</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        Sign in to access employee {pluralLower} and events.
      </p>
    </div>
  );
}

export function WorkspaceNotFoundCard() {
  return (
    <div className="flex flex-1 items-center justify-center px-4">
      <div className="w-full max-w-[25rem] rounded-2xl border bg-card px-8 py-10 text-center shadow-sm">
        <h1 className="text-xl font-semibold tracking-tight">Workspace not found</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          The organization you are trying to access does not exist or is unavailable.
        </p>
        <a href="https://afinio.co" className={cn(buttonVariants({ variant: "outline" }), "mt-6")}>
          Go to Afinio
        </a>
      </div>
    </div>
  );
}

export function ContinueAsSession({
  email,
  onContinue,
  onSwitchAccount,
}: {
  email: string | null | undefined;
  onContinue: () => void;
  onSwitchAccount: () => void;
}) {
  return (
    <div className="flex flex-1 items-center justify-center px-4">
      <div className="w-full max-w-[25rem] rounded-2xl border bg-card px-8 py-10 text-center shadow-sm">
        <h1 className="text-xl font-semibold tracking-tight">You&apos;re already signed in</h1>
        {email ? <p className="mt-2 text-sm text-muted-foreground">Continue as {email}</p> : null}
        <Button className="mt-6 w-full" onClick={onContinue}>
          Continue
        </Button>
        <button
          onClick={onSwitchAccount}
          className="mt-3 text-sm font-medium text-muted-foreground underline-offset-4 hover:underline"
        >
          Use a different account
        </button>
      </div>
    </div>
  );
}
